var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJobs = function SvgJobs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".jobs_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 16,
    x: 0.5,
    y: 6.002,
    className: "jobs_svg__a",
    rx: 3,
    ry: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 6V4a2.005 2.005 0 0 1 2-2h3a2.006 2.006 0 0 1 2 2v2M12 11.002v-1M13.5 11h-2.033a1.342 1.342 0 0 0-.5 2.587l2.064.825a1.342 1.342 0 0 1-.5 2.588H10.5M12 18.002v-1",
    className: "jobs_svg__a"
  })));
};
export default SvgJobs;